import React, { useState, useEffect } from "react";
import {
    Box,
    Grid,
    Paper,
    Typography,
    TextField,
    Button,
    Card,
    CardContent,
} from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NumbersIcon from "@mui/icons-material/Numbers";
import CodeIcon from "@mui/icons-material/Code";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import HomeIcon from "@mui/icons-material/Home";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import baseURL from "../../config";
import { useParams } from "react-router-dom";

const CrewingAgentBankDetails = () => {
    const { id: crewingAgentId } = useParams();

    const [bankDetails, setBankDetails] = useState({
        BankHolderName: "",
        bankName: "",
        accountNumber: "",
        ifscCode: "",
        branchName: "",
        bankAdress: "",
    });

    const [updatedBankDetails, setUpdatedBankDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);

    const handleBankInputChange = (e) => {
        const { name, value } = e.target;
        setBankDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };



    const handleBankSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("token");

        try {
            if (editMode && updatedBankDetails) {
                const accountId = updatedBankDetails?._id;
                if (!accountId) {
                    toast.error("No account ID found for update");
                    return;
                }

                await axios.put(
                    `${baseURL}/api/CrewinngAccount/updateCrewingAgentAccount/${accountId}`,
                    { ...bankDetails, crewingAgentId },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                console.log("Bank details updated successfully")
                toast.success("✅ Bank details updated successfully");
            } else {
                await axios.post(
                    `${baseURL}/api/CrewinngAccount/CrewingAgentAccount`,
                    { ...bankDetails, crewingAgentId },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                toast.success("✅ Bank details saved successfully");
            }
            setEditMode(false);
            fetchBankDetails();
        } catch (err) {
            console.error("❌ Error saving/updating bank details:", err.response?.data || err);
            toast.error("❌ Failed to save/update bank details");
        }
    };

    const fetchBankDetails = async () => {
        setLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await axios.get(
                `${baseURL}/api/CrewinngAccount/CrewingAgentADetailsccount/${crewingAgentId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const data = response.data.data;
            setUpdatedBankDetails(data?.bankName ? data : null);
            setBankDetails(data || bankDetails);
        } catch (err) {
            console.error("❌ Error fetching bank details:", err.response?.data || err);
            setUpdatedBankDetails(null);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchBankDetails();
    }, [crewingAgentId]);

    if (loading) return <Typography textAlign="center">Loading...</Typography>;

    const cardItems = [
        { icon: <AccountCircleIcon color="primary" />, label: "Bank Holder Name", value: updatedBankDetails?.BankHolderName },
        { icon: <AccountBalanceIcon sx={{ color: "#0288d1" }} />, label: "Bank Name", value: updatedBankDetails?.bankName },
        { icon: <NumbersIcon sx={{ color: "#2e7d32" }} />, label: "Account Number", value: updatedBankDetails?.accountNumber },
        { icon: <CodeIcon sx={{ color: "#d32f2f" }} />, label: "IFSC Code", value: updatedBankDetails?.ifscCode },
        { icon: <LocationCityIcon sx={{ color: "#f57c00" }} />, label: "Branch Name", value: updatedBankDetails?.branchName },
        { icon: <HomeIcon sx={{ color: "#7b1fa2" }} />, label: "Bank Address", value: updatedBankDetails?.bankAdress },
    ];

    return (
        <>
            {/* <ToastContainer
                position="top-right"
                autoClose={3000}
                theme="colored"
                style={{ zIndex: 999999 }}
            /> */}
            <Paper sx={{ p: 2, maxWidth: 900, mx: "auto", mt: 3, bgcolor: "#f4f6f8" }}>
                {/* Toast Container here ensures it works */}
                {/* <ToastContainer position="top-right" autoClose={3000} theme="colored" style={{ zIndex: 999999 }} /> */}

                <Box
                    sx={{
                        background: "linear-gradient(to right,rgb(185, 42, 6),rgb(192, 57, 8))",
                        p: 2,
                        borderRadius: 3,
                        mb: 3,
                        color: "#fff",
                        textAlign: "center",
                    }}
                >
                    <Typography variant="h5" fontWeight="bold">
                        Crewing Agent Bank Details
                    </Typography>
                </Box>

                {updatedBankDetails && !editMode ? (
                    <>
                        <Grid container spacing={3}>
                            {cardItems.map((item, index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <Card sx={{ p: 2, borderRadius: 3, boxShadow: 3 }}>
                                        <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                            {item.icon}
                                            <Box>
                                                <Typography variant="subtitle2" color="text.secondary">
                                                    {item.label}
                                                </Typography>
                                                <Typography variant="body1" fontWeight="bold">
                                                    {item.value || "N/A"}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>

                        <Box textAlign="center" mt={3}>
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: "#ab0d1c", "&:hover": { backgroundColor: "#ab0d1c" } }}
                                onClick={() => setEditMode(true)}
                            >
                                Update Details
                            </Button>
                        </Box>
                    </>
                ) : (
                    <Box component="form" onSubmit={handleBankSubmit}>
                        <Grid container spacing={2}>
                            {[
                                { label: "Bank Holder Name", name: "BankHolderName" },
                                { label: "Bank Name", name: "bankName" },
                                { label: "Account Number", name: "accountNumber" },
                                { label: "IFSC Code", name: "ifscCode" },
                                { label: "Branch Name", name: "branchName" },
                                { label: "Bank Address", name: "bankAdress", multiline: true, minRows: 2 },
                            ].map((field, index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <TextField
                                        label={field.label}
                                        fullWidth
                                        name={field.name}
                                        value={bankDetails[field.name]}
                                        onChange={handleBankInputChange}
                                        multiline={field.multiline || false}
                                        minRows={field.minRows || 1}
                                        required
                                    />
                                </Grid>
                            ))}
                            <Grid item xs={12} textAlign="center">
                                <Button
                                    variant="contained"
                                    type="submit"
                                    size="large"
                                    sx={{ mt: 2, backgroundColor: "#ab0d1c", "&:hover": { backgroundColor: "#ab0d1c" } }}
                                >
                                    {editMode ? "Update Bank Details" : "Save Bank Details"}
                                </Button>
                                {editMode && (
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        sx={{ mt: 2, ml: 2 }}
                                        onClick={() => setEditMode(false)}
                                    >
                                        Cancel
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                )}

            </Paper>
        </>
    );
};

export default CrewingAgentBankDetails;
